import { render, staticRenderFns } from "./testApi.vue?vue&type=template&id=72f60508&scoped=true"
import script from "./testApi.vue?vue&type=script&lang=js"
export * from "./testApi.vue?vue&type=script&lang=js"
import style0 from "./testApi.vue?vue&type=style&index=0&id=72f60508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f60508",
  null
  
)

export default component.exports